// Class component

import React from 'react';
import Button from 'react-bootstrap/Button';

type AddTodoProps = {
  // using `interface` is also ok
  addTodo: any;
};
type AddTodoState = {
  text: string;
};

export class AddTodo extends React.Component<AddTodoProps, AddTodoState> {
  state = {
    text: '',
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    this.props.addTodo(this.state.text);
    this.setState({ text: '' });
  };

  // If there is more states we can use [e.target.name] if only one - text.
  onChange = (e: any) => this.setState({ text: e.target.value });

  render() {
    return (
      <form onSubmit={this.onSubmit} style={{ display: 'flex' }}>
        <input
          type="text"
          name="text"
          placeholder="Add Todo ..."
          style={{ flex: '10', padding: '5px' }}
          value={this.state.text}
          onChange={this.onChange} // When called
        />
        <Button
          type="submit"
          value="submit"
          className="btn"
          style={{ flex: '1' }}
        >
          Add Todo
        </Button>
      </form>
    );
  }
}

export default AddTodo;
